export default "__VITE_PUBLIC_ASSET__e4c70f1b__"